import { render, staticRenderFns } from "./SfCollectedProduct.vue?vue&type=template&id=5cc73887&"
import script from "./SfCollectedProduct.vue?vue&type=script&lang=js&"
export * from "./SfCollectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SfCollectedProduct.vue?vue&type=style&index=0&id=5cc73887&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports